<script>
    export let step = 1;
</script>

<div class="order-header d-none d-md-block">
    <div class="row">
        <div class="col-2">
            <div class="header-number" class:active={step === 1}>
                <h1>1</h1>
                <span>súhrn</span>
            </div>
        </div>
        <div class="col-3">
            <div class="line"></div>
        </div>
        <div class="col-2">
            <div class="header-number" class:active={step === 2}>
                <h1>2</h1>
                <span>dodacie údaje</span>
            </div>
        </div>
        <div class="col-3">
            <div class="line"></div>
        </div>
        <div class="col-2">
            <div class="header-number" class:active={step === 3}>
                <h1>3</h1>
                <span>dokončenie</span>
            </div>
        </div>
    </div>
</div>

<style>
    .order-header {
        user-select: none;
        height: 15vh;
        padding: 1.5rem 0;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        margin-bottom: 5rem;
    }
    .order-header .header-number {
        display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
    }
    .order-header .header-number h1 {
        font-size: 1.8rem;
        padding: 1.4rem 1.9rem;
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        color: var(--color-slate-300);
        border: 1px solid var(--color-slate-200);
        margin-bottom: 1rem;
    }
    .order-header .header-number.checked h1 {
        border: 1px solid transparent;
        background-color: rgba(0, 0, 0, 0.3);
    }
    .order-header .header-number.active h1 {
        border: 1px solid var(--color-slate-100);
        background-color: var(--color-slate-200);
        box-shadow: 0 0 0 5px var(--color-slate-50);
        color: var(--color-slate-500);
    }
    .order-header .header-number.active span {
        color: var(--color-slate-500)
    }
    .order-header .header-number span {
        position: absolute;
        font-size: 20px;
        text-transform: uppercase;
        width: 14rem;
        top: 6rem;
        color: var(--color-slate-300);
    }
    .order-header .line {
        width: 100%;
        border-bottom: 1px solid var(--color-slate-200);
        margin-top: 2.5rem;
    }
</style>